import { law_unfit_list } from './regulation-unfit-item.model';

export interface law_unfit_list_extend extends law_unfit_list {
  selected?: boolean; // 新增的選擇屬性，可選
}

// 創建擴展項目的工廠函數
export function createExtendedRegulationUnfitItem(item: law_unfit_list): law_unfit_list_extend {
  return {
    ...item,
    selected: false // 預設為未選取
  };
}
